export const PERFIS = ['admin', 'gerente', 'vendedor', 'caixa', 'estoquista', 'comprador'] as const;
export type Perfil = typeof PERFIS[number];

export const PERFIL_LABEL: Record<Perfil, string> = {
  admin: 'Administrador',
  gerente: 'Gerente',
  vendedor: 'Vendedor',
  caixa: 'Caixa',
  estoquista: 'Estoquista',
  comprador: 'Comprador',
};

export const DEPARTAMENTOS = ['atendimento', 'compras'] as const;
export type Departamento = typeof DEPARTAMENTOS[number];

export const DEPARTAMENTO_LABEL: Record<Departamento, string> = {
  atendimento: 'Atendimento',
  compras: 'Compras',
};

export const DIAS_SEMANA = [
  { idx: 0, label: 'Domingo', curto: 'Dom' },
  { idx: 1, label: 'Segunda', curto: 'Seg' },
  { idx: 2, label: 'Terca', curto: 'Ter' },
  { idx: 3, label: 'Quarta', curto: 'Qua' },
  { idx: 4, label: 'Quinta', curto: 'Qui' },
  { idx: 5, label: 'Sexta', curto: 'Sex' },
  { idx: 6, label: 'Sabado', curto: 'Sab' },
] as const;

// --- Prazo de cancelamento da nota na SEFAZ ----------------------------------
// Copia UNICA: o botao Cancelar (front) decide por aqui e a mensagem de recusa da
// emissao (backend) explica por aqui. Antes o numero so existia no front e o texto
// do backend dizia "30 min" tambem pra NF-e, onde o prazo e 24h — mensagem herdada
// de um contexto que passou a mentir noutro ([DA-470]). Mexeu no prazo? Um lugar so.
export const MODELOS_NOTA = ['nfce', 'nfe'] as const;
export type ModeloNota = typeof MODELOS_NOTA[number];

export const PRAZO_CANCELAMENTO_MS: Record<ModeloNota, number> = {
  nfce: 30 * 60 * 1000,      // 30 minutos
  nfe: 24 * 60 * 60 * 1000,  // 24 horas
};

export const PRAZO_CANCELAMENTO_LABEL: Record<ModeloNota, string> = {
  nfce: '30 min',
  nfe: '24h',
};

export const MODELO_NOTA_LABEL: Record<ModeloNota, string> = {
  nfce: 'NFC-e',
  nfe: 'NF-e',
};
